import { envConfig } from '../../../../env';
import { Get, Post } from '@/service/request/server';
import { EnumContentType } from '@/constant/enums';

const baseUrl = envConfig.formalServer + "/source/file/"

function baseApi() {
    function singleUpload(data) {
        return Post(baseUrl + "singleUpload", data, {
            headers: {
                'Content-Type': EnumContentType.formData
            }
        })
    }

    function multiUpload(data) {
        return Post(baseUrl + "multiUpload", data, {
            headers: {
                'Content-Type': EnumContentType.formData
            }
        })
    }

    function download(fileId) {
        return Get(`${baseUrl}download/${fileId}`)
    }

    function update(data) {
        return Post(baseUrl + "update", data)
    }

    function deleteFile(data) {
        return Post(baseUrl + "delete", data)
    }

    function chunkUpload(data) {
        return Post(baseUrl + 'chunk/upload', data, {
            headers: {
                'Content-Type': EnumContentType.formData
            }
        });
    }

    function chunkCheckAndMerge(data) {
        return Post(baseUrl + 'chunk/checkAndMerge', data);
    }

    return {
        singleUpload,
        multiUpload,
        download,
        update,
        deleteFile,
        chunkUpload,
        chunkCheckAndMerge
    }
}

export const fileWebApi = baseApi()

